// extracted by mini-css-extract-plugin
module.exports = {"popover":"style_popover__NssoP","paper":"style_paper__1a5u5"};